'use client';

import { INTRO_ANCHOR_ID } from "@/app/features/shared/__to_be_integrated/ui/intro-anchor-id";

export default function IntroAnchor() {
    return <span id={INTRO_ANCHOR_ID} tabIndex={-1} />;
}

function getScrollParent(el: HTMLElement | null): HTMLElement | null {
    if (!el) return null;

    let parent = el.parentElement;
    while (parent) {
        const style = getComputedStyle(parent);
        if (/(auto|scroll)/.test(style.overflowY)) {
            return parent;
        }
        parent = parent.parentElement;
    }

    return null;
}

export function scrollToIntroAnchor() {
    const element = document.getElementById(INTRO_ANCHOR_ID);
    const headerHeight =
        parseFloat(
            getComputedStyle(document.documentElement)
                .getPropertyValue('--header-height')
        ) || 0;

    if (element) {
        getScrollParent(element)?.scrollTo({ top: element.offsetTop - headerHeight, behavior: 'smooth' });
    }
}
